export default __webpack_public_path__ + "static/media/border-top.c66eac5d.png";